export const breakpoints = {
  md: 48,
  xl: 80.25,
};

export const mediaQueries = key => {
  return style => `@media print, screen and (min-width: ${breakpoints[key]}em) { ${style}} `;
};
